__webpack_require__.p = "https://FeeManagementSystemUi-dev.shipbob.dev/";